<template>
  <div v-if="user.artifact" class="user-artifact">
    <nuxt-link to="/store#artifact" tag="img" :data-src="`/static_files/items/artifact-${user.artifact}.svg`" alt="user artifact" class="lazyload" />
  </div>
</template>

<script>
export default {
  props: { user: { type: Object, require: true, default: () => ({}) } }
}
</script>
